export const formatNumber = new Intl.NumberFormat('en-US')
